/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Entity } from '../model/entity/entity';
import { NameValue } from '../tool/name-value';
import { IEntity } from '../interface/IEntity';

/**
 * @deprecated {@see StandardEntity}
 */
export class GenericEntity extends Entity implements IEntity {
  public api: string;
  public idField: string;
  public labelField: string | string[];
  public displayId: boolean;
  public displayLabel: boolean;

  constructor(api: string, idField?: string, labelField?: string | string[]) {
    super();
    this.api = api;
    this.idField = idField ? idField : 'id';
    this.labelField = labelField ? labelField : 'label';
  }

  /**
   * Convert any to Entity and copy each attribute of item on the GenericEntity
   * @param item
   */
  override convert(item: any): any {
    const entity = new GenericEntity(this.api, this.idField, this.labelField);
    for (const attr in item) {
      entity[attr] = item[attr];
    }
    entity.displayId = this.displayId;
    return entity;
  }

  /**
   * Return api to get, post, put, delete...
   */
  getApi(): string {
    return this.api;
  }

  /**
   * Return id of object
   */
  getId(): string {
    return this[this.idField];
  }

  getLabel(): string {
    if (typeof this.labelField === 'string') {
      return this[<string>this.labelField];
    } else {
      const labels = [];
      for (const label of this.labelField) {
        labels.push(this[label]);
      }
      return labels.join(' ');
    }
  }

  serialize(): any {
    const obj: any = {};
    for (const prop in this) {
      if (typeof this[prop] !== 'function') {
        obj[prop] = this[prop];
      }
    }
    return obj;
  }

  /**
   * Return a string format (id) label1 label2 label3...
   */
  public override toString() {
    let label = '';
    if (this.labelField instanceof Array) {
      for (const field of this.labelField) {
        label += ' ' + this[field];
      }
    } else {
      label = this[this.labelField];
    }
    if (this.getId() && this.displayId) {
      if (label && this.displayLabel) {
        return `${this.getId()} - ${label}`;
      } else {
        return `${this.getId()}`;
      }
    } else if (this.displayLabel) {
      return label;
    } else {
      return null;
    }
  }

  public override compare(comparant: any, byLabel?: boolean): number {
    if (
      comparant instanceof Entity ||
      typeof comparant === 'string' ||
      comparant instanceof NameValue
    ) {
      return super.compare(comparant, byLabel);
    } else if (comparant[this.idField]) {
      return this.getId().localeCompare(comparant[this.idField]);
    } else if (comparant && Object.hasOwn(comparant, 'id')) {
      return this.getId().localeCompare(comparant.id);
    } else {
      return NaN;
    }
  }

  public getDisplay(): 'id' | 'label' | 'full' {
    return this.displayId && this.displayLabel
      ? 'full'
      : this.displayLabel
      ? 'label'
      : 'id';
  }
}
